"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanEarnPoints = void 0;
const points_1 = require("root/src/shared/constants/points");
const envSelect_1 = require("root/src/shared/util/envSelect");
const getCanEarnPoints = (params) => {
    var _a;
    const creatorIsPartner = envSelect_1.isDevEnv || params.isPartner;
    return ((_a = params.dropEvent) === null || _a === void 0 ? void 0 : _a.awardPoints)
        && params.ccv >= points_1.pointsMinCcv
        && params.isAbleToParticipate
        && params.isCreatorPointsAllowlisted
        && creatorIsPartner;
};
exports.getCanEarnPoints = getCanEarnPoints;
